import { render, staticRenderFns } from "./editOrganizationName.vue?vue&type=template&id=7685a9d6&scoped=true&"
import script from "./editOrganizationName.vue?vue&type=script&lang=js&"
export * from "./editOrganizationName.vue?vue&type=script&lang=js&"
import style0 from "./editOrganizationName.vue?vue&type=style&index=0&id=7685a9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685a9d6",
  null
  
)

export default component.exports